import React from 'react'
import { Link } from 'react-router-dom';

function Nav(){
    return(
        <div>
            <div className="header-nav main-nav-one">
                <nav>
                    <ul className="parent-nav">
                        <li>
                            <Link className="nav-link " to="/">
                                <span className="rolling-text"><div className="block"><span className="letter">H</span><span className="letter">O</span><span className="letter">M</span><span className="letter">E</span></div><div className="block"><span className="letter">H</span><span className="letter">O</span><span className="letter">M</span><span className="letter">E</span></div></span>
                            </Link>
                        </li>
                        <li>
                            <Link className="nav-link" to="/About">
                                <span className="rolling-text"><div className="block"><span className="letter">A</span><span className="letter">B</span><span className="letter">O</span><span className="letter">U</span><span className="letter">T</span></div><div className="block"><span className="letter">A</span><span className="letter">B</span><span className="letter">O</span><span className="letter">U</span><span className="letter">T</span></div></span>
                            </Link>
                        </li>
                        <li className="has-dropdown mega">
                            <Link className="nav-link" to="/service">
                                <span className="rolling-text"><div className="block"><span className="letter">S</span><span className="letter">E</span><span className="letter">R</span><span className="letter">V</span><span className="letter">I</span><span className="letter">C</span><span className="letter">E</span><span className="letter">S</span></div><div className="block"><span className="letter">S</span><span className="letter">E</span><span className="letter">R</span><span className="letter">V</span><span className="letter">I</span><span className="letter">C</span><span className="letter">E</span><span className="letter">S</span></div></span>
                            </Link>
                            <ul className="submenu">

                                <li><Link to="/Business-Formation">  <img
                                    className="img-fluid me-3"
                          alt="Business Formation"
                          src="assets/images/services/business-formation.png"
                          style={{ width: "50px", height: "50px" }}
                        />  Business Formation</Link></li>

                                
                                <li><Link to="/payroll-management">  <img
                                    className="img-fluid me-3"
                          alt="Payroll Management"
                          src="assets/images/services/services-icon-2.png"
                          style={{ width: "50px", height: "50px" }}
                                />  Payroll Management</Link></li>


                                <li><Link to="/book-keeping">  <img
                                    className="img-fluid me-3"
                          alt="Payroll Management"
                          src="assets/images/services/services-icon-3.png"
                          style={{ width: "50px", height: "50px" }}
                                />  Book keeping</Link></li>


                                <li><Link to="/tax">  <img
                                    className="img-fluid me-3"
                          alt="Tax"
                          src="assets/images/services/tax.png"
                          style={{ width: "50px", height: "50px" }}
                                />  Tax</Link></li>


                                  <li><Link to="/business-consultation">  <img
                                    className="img-fluid me-3"
                          alt="Business Consultations"
                          src="assets/images/services/business-consultation.png"
                          style={{ width: "50px", height: "50px" }}
                                />  Business Consultations</Link></li>
                                

                            </ul>
                        </li>
                       
                        
                        <li>
                            <Link className="nav-link" to="/contact-us">
                                <span className="rolling-text"><div className="block"><span className="letter">C</span><span className="letter">O</span><span className="letter">N</span><span className="letter">T</span><span className="letter">A</span><span className="letter">C</span><span className="letter">T</span></div><div className="block"><span className="letter">C</span><span className="letter">O</span><span className="letter">N</span><span className="letter">T</span><span className="letter">A</span><span className="letter">C</span><span className="letter">T</span></div></span>
                            </Link>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
    )
}


export default Nav